// extracted by mini-css-extract-plugin
export var alignCenter = "_8i-d";
export var bannerShown = "_8i-6";
export var buttonContent = "_8i-0";
export var cardList = "_8i-1";
export var centerContent = "_8i-2";
export var chevron = "_8i-3";
export var closePanelButton = "_8i-k";
export var conversationContextContainer = "_8i-l";
export var conversationDetailContainer = "_8i-4";
export var detailWrapper = "_8i-7";
export var dropdownButton = "_8i-e";
export var dropdownTitle = "_8i-9";
export var fullHeight = "_8i-5";
export var hidden = "_8i-a";
export var icon = "_8i-b";
export var mergeSuggestionWrapper = "_8i-m";
export var panel = "_8i-i";
export var portalButtonsWrapper = "_8i-c";
export var right = "_8i-j";
export var tableSummaryContainer = "_8i-8";
export var tableSummaryHeader = "_8i-g";
export var threeDotsButton = "_8i-f";
export var wide = "_8i-h";